import CardBase from "components/General/CardBase";
import CardWithFields from "components/General/CardWithFields";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import useFinancialsAPI from "hooks/useFinancialsAPI";

import Disclaimer from "./Disclaimer";
import getCardFields from "./getCardFields";
import { useTranslation } from "react-i18next";
import {
  isAnnuityPolicyInactive,
  isDeferredAnnuityPlanCode,
} from "js/utilities";

const ContractValues = (props) => {
  const { t } = useTranslation();
  const { policy } = props;

  const { cashValues, isLoading } = useFinancialsAPI(policy);

  const isInactiveStatus = isAnnuityPolicyInactive(policy);
  const cardFields = getCardFields(cashValues, isInactiveStatus);
  const isDeferredAnnuityPlanCodeExists = isDeferredAnnuityPlanCode(policy);

  const loadingText = t(
    "CustomerPolicyDetails-coverage-documents-annuity-card-fields-loading-text"
  );

  return (
    <EverlakeLoadingOverlay isLoading={isLoading} loadingText={loadingText}>
      {isInactiveStatus || cashValues ? (
        <CardWithFields
          additionalContent={
            <Disclaimer
              isDeferredAnnuityPlanCode={isDeferredAnnuityPlanCodeExists}
            />
          }
          ariaLabel={t(
            "CustomerPolicyDetails-coverage-documents-annuity-card-fields-aria-label"
          )}
          cardTitle={t(
            "CustomerPolicyDetails-coverage-documents-annuity-card-fields-contract-values"
          )}
          cardFields={cardFields}
        />
      ) : (
        <CardBase
          ariaLabel={t(
            "CustomerPolicyDetails-coverage-documents-annuity-card-fields-aria-label"
          )}
          cardTitle={t(
            "CustomerPolicyDetails-coverage-documents-annuity-card-fields-contract-values"
          )}
        >
          <div className="flex justify-center text-sm text-theme-text-secondary break-words">
            {t(
              "CustomerPolicyDetails-coverage-documents-annuity-card-fields-disclaimer"
            )}
          </div>
        </CardBase>
      )}
    </EverlakeLoadingOverlay>
  );
};

export default ContractValues;
